export const handleBalanceKeyDown = (e) => {
  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
    return;
  }

  if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)) {
    return;
  }

  const input = e.target.value;
  
  if (/^\d\d\.\d\d$/.test(input)) {
    e.preventDefault();
    return;
  }

  if (/^\d\d$/.test(input) && e.key !== '.') {
    e.preventDefault();
    return;
  }

  if (/^(\d|\d\d)\.\d\d$/.test(input)) {
    e.preventDefault();
    return;
  }
};

export const formatBalanceValue = (value) => {
  if (value === null || value === undefined || value === '') return '';
  
  let numValue = parseFloat(value);
  
  if (numValue > 99.99) {
    return "99.99";
  }
  
  if (value.toString().includes('.') && value.toString().split('.')[1].length > 2) {
    return numValue.toFixed(2);
  }
  
  return value.toString();
}; 